module.exports = __webpack_public_path__ + "img/logout.9e2dc53d.svg";